<template>
<div class="select-code">
    <div class="area" :class="{mb: mb}" :style="{'background-image':`url(${ctFlag})`}">
        <i>+</i>{{ code }}
        <select class="scode" @change="changeCode($event)" v-html="countrysHtml">
        </select>
    </div>
</div>
</template>
<script>

import countrys from '../js/country';
import api from '../js/api';

export default {
    name: 'select-code',
    props: {
        mb: { type: String, default: '' }
    },
    data() {
        return {
            countrysHtml: '',
            countryCode: '',
            code: 1,
            ctFlag: '//esx.esxscloud.com/live/search3/AS.png'
        };
    },
    components: {
    },
    methods: {
        changeCode(e) {
            const { options } = e.target;
            const ele = options[options.selectedIndex];
            const country = ele.getAttribute('data-country');
            this.ctFlag = `//esx.esxscloud.com/live/search3/${country}.png`;
            this.code = ele.value;
            this.$emit('selectCode', this.code);
        },
        setSelected() {
            api.getCountryCodeByIp().then((data) => {
                this.countryCode = data.countryCode;
                const regStr = `data-country="${this.countryCode}"`;
                const regexp = new RegExp(regStr);
                const countrysMap = countrys.map((item) => {
                    item = item || '';
                    if (regexp.test(item)) {
                        this.ctFlag = `//esx.esxscloud.com/live/search3/${this.countryCode}.png`;
                        [this.code] = item.match(/\d+/g);
                        this.$emit('selectCode', this.code);
                        item = item.replace(regexp, `${regStr} selected="selected"`);
                        return item;
                    } else {
                        return item;
                    }
                });
                this.countrysHtml = countrysMap.join('');
            });
        }
    },

    beforeMount() {
        this.setSelected();
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.select-code {
    div, input {
        // -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color:transparent;
        outline: none;
        border: 0;
    }
    position: absolute;
    height: 100%;
    .area {
        position: absolute;
        left: 0;
        bottom: 4px;
        box-sizing: border-box;
        background:rgba(247,247,247,1);
        border-radius:4px;
        // width: 76px;
        height: 26px;
        padding-left: 29px;
        padding-right: 8px;
        font-size:15px;
        font-family: 'RobotoRegular';
        font-weight: normal;
        color:rgba(51,51,51,1);
        line-height:26px;
        // background-image: url('../images/delete.png');
        background-repeat: no-repeat;
        background-size: 17px 17px;
        background-position: 8px center;
        text-align: center;
        cursor: pointer;

        &.mb {
            bottom: rem(4);
            border-radius:rem(4);
            height: rem(26);
            padding-left: rem(29);
            padding-right: rem(8);
            font-size:15px;
            line-height:rem(26);
            background-size: rem(17) rem(17);
            background-position: rem(8) center;
            i {
                top: rem(-1);
            }
        }

        i {
            position: relative;
            top: -1px;
        }
        .scode {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            border: none;
            background: none;
            overflow: hidden;
            -webkit-appearance: none;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            outline: none;
            opacity: 0;
        }
    }
}
</style>
